<style scoped lang="scss">
::v-deep .el-select .el-input {
  width: auto !important;
}

.el-select .el-input .gantt_split_parent,
.gantt_split_subproject {
  opacity: 0;
}

::v-deep .gantt_task_line.gantt_task_inline_color .gantt_task_progress {
  background-color: rgba(54, 54, 54, 0.2);
  opacity: 1;
}

::v-deep .scale_class {
  background-color: #f5f7fa !important;
}

::v-deep .column_class {
  background-color: #f5f7fa !important;
}

::v-deep .gantt_scale_cell {
  color: #454545 !important;
}

::v-deep .gantt_task_line.gantt_task_inline_color {
  border-color: #e8e8e8;
}

::v-deep .gantt_task_line {
  border: none !important;
  border-radius: 0px;
}

::v-deep .column_weekend {
  background-color: #ecf5ff !important;
}

::v-deep .scale_weekend {
  color: #454545 !important;
  background-color: #ecf5ff !important;
}
</style>
<style lang="scss"></style>
<template>
  <div id="device_load_gantt" style="width: 100%;height: 100%;padding: 20px;display:flex;flex-direction: column;" :style="{ width: exportWidth == 0 ? '100%' : exportWidth + 'px', height: exportHeight == 0 ? '100%' : exportHeight + 'px' }">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"></yi_curd_table>

    <div v-if="isExporting == false" style="width: 100%;">
      <el-form size="mini" :inline="true" class="demo-form-inline">
        <el-form-item :label="$t('shengchangongdanhao')">
          <el-input v-model="woNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('kaishishijian')">
          <el-date-picker :clearable="false" size="mini" v-model="date" type="date" :placeholder="$t('')" value-format="yyyy-MM-dd"> </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('shebeimingcheng')">
          <yi_data_select size="mini" :multiple="true" :type="'equipment'" :ids.sync="equipmentIdList"> </yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('chanpinmingcheng')">
          <yi_data_select :width="'250px'" size="mini" :multiple="true" :type="'material2'" :ids.sync="materialIdList"> </yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('shezhitianshu')">
          <el-input-number style="margin-left: 4px;" size="mini" v-model="days" controls-position="right" @change="handleChange" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('suoshuzuzhi')">
          <yi_data_select type="organization" :ids.sync="yt.conditions.orgId"></yi_data_select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getGantt()" size="mini" type="primary" plain>{{ $t("sousuo") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="clearDate()">{{ $t("chongzhi") }} </el-button>
        </el-form-item>
      </el-form>

      <div style="display: flex;align-items: center;justify-content: space-between;padding-bottom: 15px;">
        <div style="display: flex;font-size: 14px;">
          <p style="font-weight: 700;color: #67C23A;">{{ $t("shengchanzhong") }}</p>
          <p style="font-weight: 700;color: #606266;margin-left: 12px;">{{ production }}</p>
          <p style="font-weight: 700;color: #E6A23C;margin-left: 50px;">{{ $t("fafang") }}</p>
          <p style="font-weight: 700;color: #606266;margin-left: 12px;">{{ giveout }}</p>
          <p style="font-weight: 700;color: #F56C6C;margin-left: 50px;">{{ $t("zanting") }}</p>
          <p style="font-weight: 700;color: #606266;margin-left: 12px;">{{ pause }}</p>
        </div>
        <div>
          <el-button size="mini" @click="scheduling" type="primary" v-if="utils.checkPower('web_production_management_device_load_pagePlan')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '设备负荷-排产' } }">{{ $t("paichan") }}</el-button>
          <el-button @click="getGantt()" size="mini" type="primary" plain :loading="ganttLoading">{{ $t("shuaxin") }}</el-button>
          <el-button style="margin-left: 10px;" @click="exportPic()" size="mini" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '设备负荷-导出' } }">{{ $t("daochu") }}</el-button>
        </div>
      </div>
    </div>

    <div style="width:100%;flex:1;" id="ganttContainer" class="ganttContainer" ref="ganttContainer"></div>
    <el-drawer :visible.sync="isShowDetailDialog" :show-close="false" :direction="'rtl'" :size="574" :destroy-on-close="true" :withHeader="false">
      <div style="margin: 40px 28px;">
        <!-- 状态  1新建、2发放、3生产中、4暂停、5首工序完工、6完工、7关闭、8已调拨  -->
        <el-button v-if="loadStatus == 2 || loadStatus == 4" size="mini" @click="startWo" type="primary">{{ $t("kaishi") }} </el-button>
        <el-button v-if="loadStatus == 3" size="mini" @click="stop" type="danger">{{ $t("zanting") }}</el-button>
        <el-button v-if="loadStatus == 2 || loadStatus == 4" size="mini" @click="allot" type="success">{{ $t("diaobo") }} </el-button>
        <el-button v-if="loadStatus == 2" size="mini" @click="showUpdateTimeDialog" type="success">{{ $t("xiugaijihuashijian") }} </el-button>
        <el-button v-if="loadStatus == 2" size="mini" @click="showUpDateWoSortDialog" type="primary">{{ $t("xiugaigongdanshunxu") }} </el-button>
        <el-tabs v-model="activeName">
          <el-tab-pane v-for="order in currentOrders" :label="order.material.name" :name="order.id + ''">
            <el-progress style="margin-bottom: 10px;" :percentage="parseFloat(((order.productionQuantity / order.planQuantity) * 100).toFixed(1))"> </el-progress>
            <el-descriptions :column="1">
              <el-descriptions-item :label="$t('shebeimingcheng')">{{ order.equipment.name }} </el-descriptions-item>
              <el-descriptions-item :label="$t('shengchangongdanhao')">{{ order.no }}</el-descriptions-item>
              <el-descriptions-item :label="$t('chanpinbianma')">{{ order.material.code }} </el-descriptions-item>
              <el-descriptions-item :label="$t('chanpinmingcheng')">{{ order.material.name }} </el-descriptions-item>
              <el-descriptions-item :label="$t('mojubianhao')">{{ order.mould.no }}</el-descriptions-item>
              <el-descriptions-item :label="$t('mojumingcheng')">{{ order.mould.name }} </el-descriptions-item>
              <el-descriptions-item :label="$t('moqiangshu')">{{ order.cavity }}</el-descriptions-item>
              <el-descriptions-item :label="$t('jihuashuliang')">{{ order.planQuantity }} </el-descriptions-item>
              <el-descriptions-item :label="$t('shengchanshuliang')">{{ order.productionQuantity }} </el-descriptions-item>
              <el-descriptions-item :label="$t('shougongxuwangongshijian')">
                <span v-if="order.woProcedureList.length > l"></span>
                <span v-if="order.woProcedureList.length == l">{{ dayjs(currentTask.end_date).format("YYYY-MM-DD HH:mm:ss") }}</span>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('shijikaishishijian')">
                {{ order.actualStartTime ? dayjs.unix(order.actualStartTime / 1000).format("YYYY-MM-DD HH:mm:ss") : "-" }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('wangongyuceshijian')">
                {{ dayjs(currentTask.end_date).format("YYYY-MM-DD HH:mm:ss") }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('shengyushijian(xiaoshi)')">
                {{ order.remainder != null ? order.remainder : "" }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('biaozhunzhouqi')">{{ order.standardCycle + $t("miao/mo") }} </el-descriptions-item>
              <el-descriptions-item :label="$t('ERPgongdanhao')">{{ order.erpNo }}</el-descriptions-item>
              <el-descriptions-item :label="$t('gongyizhinanbianma')">
                {{ order.craftGuide && order.craftGuide.code }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('guige')">
                {{ order.material.spec }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('dangqianliaohao')">
                {{ order.material.no }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('yanse')">
                {{ order.material.color }}
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-dialog v-dialog-drag :show-close="true" :visible.sync="showSchedulDialog" width="80%" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <production_plan></production_plan>
      </div>
    </el-dialog>
    <!--调拨-->
    <el-dialog v-dialog-drag :show-close="true" :visible.sync="isShowAllocateDialog" width="450px" :close-on-click-modal="false" append-to-body="append-to-body">
      <!--<div class="dialog-scroller"></div>-->
      <el-form v-if="isShowAllocateDialog" :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
        <el-form-item class="noborder" :label="$t('shengchangongdanhao')" required>
          <el-input disabled v-model="produceNo"></el-input>
        </el-form-item>
        <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
          <yi_cross_select disabled multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="materialIds"> </yi_cross_select>
        </el-form-item>
        <el-form-item class="noborder" :label="$t('jihuashuliang')" required>
          <el-input disabled v-model="planQuantity"></el-input>
        </el-form-item>
        <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
          <el-input disabled v-model="leftProductionQuantity"></el-input>
        </el-form-item>
        <el-form-item :label="$t('mujubianhao/mingcheng')" required>
          <yi_cross_select :max="1" :selectTitle="'no,name'" @getItems="getItems" :component="'web_order_management_production_plan_mold_list'" :ids.sync="mouldId" :materialId="materialIds"> </yi_cross_select>
        </el-form-item>
        <el-form-item :label="$t('shebeimingcheng')" required>
          <yi_cross_select :max="1" :component="'web_production_management_work_order_execution_equipment_list'" :ids.sync="equipmentId" :mouldId="mouldId" :materialId="materialIds"> </yi_cross_select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowAllocateDialog = false">{{ $t("quxiao") }}</el-button>
        <el-button :loading="yt.editObj.loading" size="mini" @click="allocation" type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
    <!--修改时间-->
    <el-dialog v-dialog-drag :show-close="true" :visible.sync="isShowUpDateTimeDialog" width="450px" :close-on-click-modal="false" append-to-body="append-to-body">
      <!--<div class="dialog-scroller"></div>-->
      <el-form v-if="currentOrders.length > 0" :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
        <el-form-item class="noborder" :label="$t('yuanjihuakaishishijian')" required>
          {{ dayjs(currentOrders[0].planStartTime).format("YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item class="noborder" :label="$t('yuanjihuawanchengshijian')" required>
          {{ dayjs(currentOrders[0].planEndTime).format("YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item :label="$t('xianjihuakaishishijian')" required>
          <yi_time_input type="datetime" :time.sync="timeForm.planStartTime"> </yi_time_input>
        </el-form-item>
        <el-form-item :label="$t('xianjihuawanchengshijian')" required>
          <yi_time_input type="datetime" :time.sync="timeForm.planEndTime"> </yi_time_input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowUpDateTimeDialog = false">{{ $t("quxiao") }}</el-button>
        <el-button :loading="yt.editObj.loading" size="mini" @click="updateTime" type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 修改工单顺序 -->
    <el-dialog v-dialog-drag :show-close="true" :visible.sync="isShowUpDateWoSortDialog" width="450px" :close-on-click-modal="false" append-to-body="append-to-body">
      <!--<div class="dialog-scroller"></div>-->
      <el-form v-if="currentOrders.length > 0" :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
        <el-form-item :label="$t('yuangongdanshunxu')">
          <yi_number_input disabled :min="1" :type="number" :start.sync="woSort"></yi_number_input>
        </el-form-item>
        <el-form-item :label="$t('xiangongdanshunxu')" required>
          <yi_number_input :min="1" :type="number" :start.sync="woSortForm.woNewSort"></yi_number_input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowUpDateWoSortDialog = false">{{ $t("quxiao") }}</el-button>
        <el-button :loading="loading" size="mini" @click="updateWoSort" type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import production_plan from "@@/pages/web/order_management/production_plan/list";
import html2canvas from "html2canvas";

const gantt = Gantt.getGanttInstance();
export default {
  name: "web_production_management_device_load_index",
  components: {
    production_plan,
  },
  data() {
    return {
      ganttLoading: false,
      isShowUpDateTimeDialog: false,
      isShowUpDateWoSortDialog: false,
      woSortForm: {
        woNewSort: null,
      },
      timeForm: {
        planStartTime: null,
        planEndTime: null,
      },

      loading: false,
      showSchedulDialog: false,
      isShowAllocateDialog: false,
      loadStatus: null,
      produceNo: null,
      woSort: null,
      materialIds: null,
      equipmentId: null,
      mouldId: null,
      planQuantity: null,
      leftProductionQuantity: null,
      startWoId: null,
      activeName: null,
      isShowDetailDialog: false,
      giveout: 0,
      pause: 0,
      production: 0,
      tasks: {
        data: [],
      },
      currentTask: {},
      currentOrders: [],

      //导出参数
      exportWidth: 0,
      exportHeight: 0,
      isExporting: false,

      //天数
      date: this.dayjs().format("YYYY-MM-DD"),
      days: 30,
      eqs: [],
      woNo: "",
      materialIdList: [],
      equipmentIdList: [],
    };
  },
  watch: {
    showSchedulDialog: {
      handler(n) {
        if (n == false) {
          this.getGantt();
        }
      },
      immediate: false,
      deep: true,
    },
  },
  created() { },
  destroyed() {
    gantt.clearAll();
  },
  mounted() {
    // gantt.config.autosize = true
    // gantt.setWorkTime({hours:["00:00-23:59"]})
    gantt.config.scale_height = 50;
    gantt.config.min_column_width = 120;
    gantt.config.time_step = 1;
    gantt.i18n.setLocale("cn");
    gantt.config.duration_unit = "minute";
    gantt.config.drag_links = false;
    gantt.config.drag_move = false;
    gantt.config.drag_progress = false;
    gantt.config.drag_resize = false;
    gantt.config.date_format = "%Y-%m-%d %H:%i";
    gantt.templates.grid_file = function (item) {
      return "";
    };
    gantt.templates.scale_row_class = function (scale) {
      return "scale_class";
    };
    gantt.templates.grid_header_class = function (columnName, column) {
      return "column_class";
    };
    gantt.templates.grid_row_class = function (columnName, column) {
      return "column_class";
    };
    gantt.templates.timeline_cell_class = function (task, date) {
      if (date.getDay() == 0 || date.getDay() == 6) {
        return "column_weekend";
      }
    };

    gantt.config.scales = [
      {
        unit: "month",
        step: 1,
        format: "%Y" + this.$t("nian") + "%M",
        css: function (date) {
          return "scale_class";
        },
      },
      {
        unit: "day",
        step: 1,
        format: "%d %D",
        css: function (date) {
          if (date.getDay() == 0 || date.getDay() == 6) {
            return "scale_weekend";
          } else {
            return "scale_class";
          }
        },
      },
    ];
    gantt.config.columns = [
      {
        name: "text",
        label: "<img style='object-fit: contain;width: 150px;height: 50px' src='" + require("@@/assets/img/web/production_management/gantt-task1.svg") + "' />",
        tree: true,
        width: 136,
      },
    ];
    gantt.attachEvent("onTaskDblClick", (id, e) => {
      const task = gantt.getTask(id);
      this.currentTask = task;
      this.getGanttDetail(id);
      //return false就不会执行默认的弹框操作
      return false;
    });

    this.getGantt();
  },
  methods: {
    //排产
    scheduling() {
      this.showSchedulDialog = true;
    },
    //开始
    startWo() {
      let params = {};
      params.id = this.startWoId;
      this.loading = true;
      this.http
        .post("/web/production/wo/check", params)
        .then((res) => {
          this.loading = false;
          if (res.data == true) {
            this.start();
          } else {
            this.$confirm(this.$t("cunzaizantinggongdandetishi"), this.$t("tishi"), {
              confirmButtonText: this.$t("rengjixukaishi"),
              cancelButtonText: this.$t("quxiaokaishi"),
              type: "warning",
            })
              .then(() => {
                this.start();
              })
              .catch(() => { });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.utils.errorMessage(err);
        });
    },
    start() {
      return this.http
        .post("/web/production/wo/start", this.startWoId)
        .then((res) => {
          this.getGantt();
          this.$message.success(this.$t(res.msg));
          this.isShowDetailDialog = false;
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        });
    },
    //暂停
    stop() {
      return this.http
        .post("/web/production/wo/stop", this.startWoId)
        .then((res) => {
          this.getGantt();
          this.$message.success(this.$t(res.msg));
          this.isShowDetailDialog = false;
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        });
    },
    //调拨
    allot() {
      this.isShowAllocateDialog = true;
    },
    //调拨保存
    async allocation() {
      let params = {
        id: parseInt(this.startWoId),
        equipmentId: this.equipmentId,
        mouldId: this.mouldId,
      };
      return await this.http
        .post("/web/production/wo/allot", params)
        .then((res) => {
          this.isShowAllocateDialog = false;
          this.isShowDetailDialog = false;
          this.$message.success(this.$t(res.msg));
          this.getGantt();
          // this.getGanttDetail(this.startWoId)
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        });
    },
    showUpdateTimeDialog() {
      this.isShowUpDateTimeDialog = true;
    },
    showUpDateWoSortDialog() {
      this.isShowUpDateWoSortDialog = true;
    },

    async updateTime() {
      let params = {
        id: parseInt(this.startWoId),
        planStartTime: this.timeForm.planStartTime,
        planEndTime: this.timeForm.planEndTime,
      };
      return await this.http
        .post("/web/production/wo/equipment/gantt/save", params)
        .then((res) => {
          this.isShowUpDateTimeDialog = false;
          this.isShowDetailDialog = false;
          this.timeForm = {
            planStartTime: null,
            planEndTime: null,
          };
          this.$message.success(this.$t(res.msg));
          this.getGantt();
          // this.getGanttDetail(this.startWoId)
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        });
    },
    async updateWoSort() {
      this.loading = true;
      let params = {
        id: parseInt(this.startWoId),
        priority: this.woSortForm.woNewSort,
      };
      return await this.http
        .post("/web/production/wo/equipment/gantt/updateWoSort", params)
        .then((res) => {
          this.isShowUpDateWoSortDialog = false;
          this.isShowDetailDialog = false;
          this.woSortForm.woNewSort = 1;
          this.loading = false;
          this.$message.success(this.$t(res.msg));
          this.getGantt();
          // this.getGanttDetail(this.startWoId)
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.loading = false;
        });
    },
    clearDate() {
      this.woNo = "";
      this.data = "";
      this.days = 30;
      this.equipmentIdList = [];
      this.materialIdList = [];
      this.date = this.dayjs().format("YYYY-MM-DD");
      this.getGantt();
      this.yt.conditions.orgId = "";
    },
    handleChange() {
      this.getGantt();
    },
    // 导出图片
    exportPic() {
      if (this.isExporting) {
        return;
      }
      this.isExporting = true;
      this.exportWidth = document.getElementById("device_load_gantt").getElementsByClassName("gantt_task_bg")[0].offsetWidth + 135;
      this.exportHeight = document.getElementById("device_load_gantt").getElementsByClassName("gantt_task_bg")[0].offsetHeight + 135;
      setTimeout(() => {
        gantt.setSizes();
      }, 300);

      setTimeout(() => {
        html2canvas(document.getElementById("device_load_gantt"), {
          // backgroundColor: 'white',
          // useCORS: true,
          // scale: 1,
          windowWidth: 2000, // document.getElementById('ganttContainer').scrollWidth,
          windowHeight: document.getElementById("ganttContainer").scrollHeight,
        }).then((canvas) => {
          let dataURL = canvas.toDataURL("image/png");
          if (dataURL !== "") {
            var a = document.createElement("a");
            a.download = "gantt";
            a.href = dataURL;
            a.click();
          }
        });
      }, 600);

      setTimeout(() => {
        this.exportWidth = 0;
        this.exportHeight = 0;
        this.getGantt();
        this.isExporting = false;
      }, 900);
    },
    getGanttDetail(id) {
      this.startWoId = id;
      this.http
        .get("/web/production/wo/equipment/gantt/detail", {
          params: {
            woId: id,
          },
        })
        .then((res) => {
          this.currentOrders = res.data;
          // 获取系统当前时间
          const now = new Date();
          this.currentOrders.forEach((item) => {
            setTimeout(() => {
              this.loadStatus = item.status;
              //生产工单号
              this.produceNo = item.no;
              this.materialIds = item.materialId;
              this.mouldId = item.mouldId;
              this.equipmentId = item.equipmentId;
              this.planQuantity = item.planQuantity;
              this.leftProductionQuantity = item.leftProductionQuantity;
              this.woSort = item.priority;
              console.log("woSort", this.woSort);
            }, 300);

            // 获取preFinishTime的值并转换成Date对象
            if (item.preFinishTime !== null) {
              const preFinishTime = new Date(item.preFinishTime);
              // 比较preFinishTime和当前时间的大小
              if (preFinishTime > now) {
                // 计算时间差并保留一位小数
                const diff = (preFinishTime - now) / 3600000; // 一小时等于3600000毫秒
                const hours = diff.toFixed(1);
                this.$set(item, "remainder", hours);
              } else {
                const defaultValue = "0.0";
                this.$set(item, "remainder", defaultValue);
              }
            }
          });
          console.log("preFinishTime", this.currentOrders);
          if (this.currentOrders.length > 0) {
            this.activeName = res.data[0].id + "";
            this.isShowDetailDialog = true;
          }
        })
        .catch((error) => {
          this.utils.errorMessage(error);
        });
    },
    getGantt() {
      console.log("this.orgId", this.yt.conditions.orgId);
      gantt.clearAll();
      this.ganttLoading = true;
      this.http
        .get("/web/production/wo/equipment/gantt", {
          params: {
            orgId: this.yt.conditions.orgId,
          },
        })
        .then((res) => {
          this.giveout = res.data.giveout;
          this.pause = res.data.pause;
          this.production = res.data.production;
          this.eqs = res.data.equipentList;
          let data = [];

          console.log("打印", this.equipmentIdList);
          console.log("打印", this.materialIdList);

          let startTime = this.dayjs(this.date).valueOf();
          let endTime = this.dayjs(this.date).valueOf() + this.days * 24 * 60 * 60 * 1000;

          console.log(startTime + "|" + endTime);

          for (var i = 0; i < this.eqs.length; i++) {
            let eq = this.eqs[i];

            if (this.woNo != null && this.woNo != "") {
              let filterNum = 0;
              for (var j = 0; j < eq.taskList.length; j++) {
                if (eq.taskList[j].woNo.indexOf(this.woNo) != -1) {
                  filterNum++;
                }
              }
              if (filterNum == 0) {
                continue;
              }
            }
            var check = false;

            if (this.equipmentIdList != null && this.equipmentIdList.length > 0) {
              for (let e = 0; e < this.equipmentIdList.length; e++) {
                let equipmentId = this.equipmentIdList[e];
                if (equipmentId == eq.equipmentId) {
                  check = true;
                }
              }
              console.log("匹配设备结果,", check);

              if (check != true) {
                continue;
              }
            }

            data.push({
              id: eq.equipmentId,
              text: eq.equipmentName,
              start_date: new Date(startTime),
              // start_date: this.dayjs.unix(eq.startTime / 1000).format('YYYY-MM-DD HH:mm'),
              duration: 0,
              progress: 0,
              render: "split",
              parent: null,
              type: "subproject",
              // color:'transparent',
              textColor: "transparent",
            });

            for (var j = 0; j < eq.taskList.length; j++) {
              let wo = eq.taskList[j];

              if (this.woNo != null && this.woNo != "") {
                console.log(wo.woNo.indexOf(this.woNo));
                if (wo.woNo.indexOf(this.woNo) == -1) {
                  continue;
                }
              }
              var check2 = false;

              if (this.materialIdList != null && this.materialIdList.length > 0) {
                for (let e = 0; e < this.materialIdList.length; e++) {
                  let materialId = this.materialIdList[e];
                  if (materialId == wo.materialId) {
                    check2 = true;
                  }
                }
                console.log("匹配设备结果2,", check);

                if (check2 != true) {
                  continue;
                }
              }

              let countStartTime = wo.startTime >= startTime ? wo.startTime : startTime;
              let countEndTime = wo.endTime >= endTime ? endTime : wo.endTime;

              data.push({
                id: wo.woId,
                text: wo.materialName + " " + (wo.progress * 100).toFixed(1) + "%",
                start_date: this.dayjs.unix(countStartTime / 1000).format("YYYY-MM-DD HH:mm:ss"),
                duration: (countEndTime - countStartTime) / 1000 / 60,
                progress: wo.progress,
                parent: eq.equipmentId,
                color: {
                  2: "#EBB563",
                  3: "#85CE61",
                  4: "#F78989",
                }[wo.status],
              });
            }
          }
          console.log(data);
          this.tasks.data = data;
          gantt.init(this.$refs.ganttContainer);
          gantt.parse(this.tasks);

          if (this.days == null) {
            gantt.config.start_date = null;
            gantt.config.end_date = null;
          } else {
            gantt.config.start_date = new Date(startTime);
            gantt.config.end_date = new Date(endTime);
          }

          setTimeout(() => {
            gantt.setSizes();
          }, 0);
        })
        .catch((error) => { })
        .finally(() => {
          this.ganttLoading = false;
        });
    },
  },
};
</script>
